import { Stack, Typography } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { COLORS } from '../../utils/Application_Constants';

function PaperTimesheetBadge() {
    return (
        <Stack direction="row" alignItems="center" spacing={0.5}>
            <DescriptionOutlinedIcon sx={{ color: COLORS.LT_MIDNIGHT50 }} />
            <Typography sx={{ color: COLORS.LT_MIDNIGHT50, mt: '2px !important' }}>
                Paper Timesheet
            </Typography>
        </Stack>
    );
}

export default PaperTimesheetBadge;
